import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accountActions } from '../../redux/actions';
import { Modal, Row, Checkbox, Typography } from 'antd';
import Localization from '../../utils/localization';
import './styles.scss';

const { Title } = Typography;

const Metrics = ({ isMetricsOpen, setIsMetricsOpen, mainAccount }) => {
    const dispatch = useDispatch();
    const updatingAccount = useSelector((state) => state.accounts.updatingAccount);

    const [isNumeric, setIsNumeric] = useState(false);
    const [isRatio, setIsRatio] = useState(false);
    const [isUnit, setIsUnit] = useState(false);

    useEffect(() => {
        if (!mainAccount) return;

        setIsNumeric(mainAccount.numeric);
        setIsRatio(mainAccount.ratio);
        setIsUnit(mainAccount.unit);
    }, [mainAccount]);

    const handleOk = () => {
        const updateAccount = { ...mainAccount };

        updateAccount.numeric = isNumeric;
        updateAccount.ratio = isRatio;
        updateAccount.unit = isUnit;

        if (!updatingAccount) {
            dispatch(accountActions.updateAccount(mainAccount, updateAccount));
        }
        handleCancel();
    };

    const handleCancel = () => {
        setIsMetricsOpen(false);
    };

    const onChangeNumeric = () => {
        setIsNumeric(true);
        setIsRatio(false);
        setIsUnit(false);
    };

    const onChangeRatio = () => {
        setIsNumeric(false);
        setIsRatio(true);
        setIsUnit(false);
    };

    const onChangeUnit = () => {
        setIsNumeric(false);
        setIsRatio(false);
        setIsUnit(true);
    };

    const renderMetrics = () => {
        return (
            <div>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountMetricNumeric}{' '}
                    </Title>
                    <Checkbox
                        checked={isNumeric}
                        style={{ marginTop: '17px', marginLeft: '141px' }}
                        onChange={onChangeNumeric}
                    />
                </Row>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountMetricRatio}{' '}
                    </Title>
                    <Checkbox
                        checked={isRatio}
                        style={{ marginTop: '17px', marginLeft: '165px' }}
                        onChange={onChangeRatio}
                    />
                </Row>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountMetricUnit}{' '}
                    </Title>
                    <Checkbox
                        checked={isUnit}
                        style={{ marginTop: '17px', marginLeft: '174px' }}
                        onChange={onChangeUnit}
                    />
                </Row>
            </div>
        );
    };

    return (
        <Modal
            bodyStyle={{
                minHeight: '20vh',
                display: 'flex',
                flexDirection: 'column',
            }}
            style={{
                minWidth: '45vh',
                display: 'flex',
                justifyContent: 'center',
            }}
            title={Localization.accountStructure.accountMetric}
            visible={isMetricsOpen} // not deprecated in our version
            onOk={handleOk}
            confirmLoading={false}
            onCancel={handleCancel}
        >
            {renderMetrics()}
        </Modal>
    );
};

export default Metrics;
